/**
 * components/inspection/workplaceScope.js
 * АЖЛЫН БАЙРЫГ ЦЕХ · ХЭСЭГ · ГРУППЭЭР хумих — НЭГ эх сурвалж.
 *
 * ⚠ ЯАГААД ТУСДАА МОДУЛЬ ВЭ: энэ шүүлт ХОЁР удаа гэм гаргасан.
 *   2026-10-29 (①) группийн хумилт огт байхгүй байв;
 *   2026-10-29 (②) `want = [section, tseh]` дээр `.some()` хийдэг тул
 *     `near(w.tseh_code, tseh)` нь тухайн ЦЕХИЙН БҮХ мөрт тэнцэж,
 *     хэсгийн шүүлт УТГАГҮЙ болж байв — хэрэглэгч: «чеклист дээр
 *     хамаагүй ажлын байрууд орж ирж байна».
 *   Хэмжсэн (лавлахын бодит дата):
 *     цех 23 · хэсэг 2335 → 106 мөр гарч байсан, ҮНЭН нь 16
 *     цех 25 · хэсэг 2505 →  16 мөр гарч байсан, ҮНЭН нь  1
 *   Тул логикийг компонентоос салгаж, тесттэй болгов.
 *
 * ⚠ КОДЫН КОНВЕНЦ (`xab.bn_workplace`):
 *     tseh_code — ЦЕХ/хэлтэс (заавал)
 *     bn_code   — ХЭСЭГ (сонголттой; ХООСОН = «тэр цехийн бүх хэсэгт»)
 *     grp_code  — ГРУПП (сонголттой; ХООСОН = «тэр хэсгийн бүх группт»)
 *   Код нь ШАТЛАЛТАЙ: 23 → 2335 → 233501.
 */

/** Зөвхөн цифр — лавлахад зай, зураас орсон байж болно. */
export const digits = (v) => String(v || "").replace(/\D/g, "");

/** Хоёр чиглэлт угтварын таарц (аль нь ч нөгөөгийн өвөг байж болно). */
export const near = (a, b) => {
  const x = digits(a);
  const y = digits(b);
  if (!x || !y) return false;
  return x.startsWith(y) || y.startsWith(x);
};

/**
 * Ажлын байруудыг хамрах хүрээгээр хумина.
 *
 * @param {Array}  rows               лавлахын мөрүүд
 * @param {Object} scope              {tseh, section, grp} — кодууд
 * @returns {{rows: Array, widened: boolean}}
 *   `widened = true` — хэсэг/группт байр БҮРТГЭГДЭЭГҮЙ тул ЦЕХИЙН
 *   жагсаалт руу буув. Дуудагч тал үүнийг ИЛТ харуулах ёстой.
 *
 * ⚠ ЦЕХ нь ҮРГЭЛЖ таарах ёстой. `bn_code` хоосон мөр нь «ТЭР ЦЕХИЙН
 *   бүх хэсэгт» гэсэн утгатай — БҮХ цехийнх БИШ. Цехээр хумихгүй бол
 *   цех 23-ын шалгалтад цех 25-ын лабораторийн өрөөнүүд орж ирнэ.
 *
 * ⚠ `tseh_code` ХООСОН мөрийг `bn_code`-оор авна: лавлахын хуучин
 *   бичлэгүүдэд цехийн код дутуу байдаг.
 *
 * ⚠ ХООСОН бол ЦЕХ руу БУУНА, хоригловол ажил зогсоно: III шатны
 *   шалгалтын `bn_code` нь ШАЛГАГЧИЙН нэгж байдаг (ж: 230102 «ХАБЭА
 *   товчоо») атал үзэх байрууд цехийн бусад хэсэгт байдаг. Хатуу
 *   шүүвэл 0 гарч, шалгагч ажлын байраа ОГТ сонгож чадахгүй болно.
 *   Хумилт нь АНХААРУУЛГА, хориг БИШ.
 */
export function filterWorkplaces(rows, scope = {}) {
  const t = digits(scope.tseh);
  const sc = digits(scope.section);
  const g = digits(scope.grp);
  const all = Array.isArray(rows) ? rows : [];

  const inCex = (w) => {
    if (!t) return true;
    const wts = digits(w && w.tseh_code);
    const wbn = digits(w && w.bn_code);
    return near(wts, t) || (!wts && near(wbn, t));
  };
  /* Хэсэг: хоосон (цех даяар) ЭСВЭЛ угтвараар холбоотой. Хоёр чиглэлт
     нь ЗӨВ — байр хэсгээс ДООШ (группийн түвшинд) ч, ДЭЭШ (цехийн
     түвшинд) ч бүртгэгдсэн байж болно. */
  const inSection = (w) => {
    if (!sc) return true;
    const wbn = digits(w && w.bn_code);
    return !wbn || sc.startsWith(wbn) || wbn.startsWith(sc);
  };
  /* ⚠ ГРУППГҮЙ мөрийг ҮЛДЭЭНЭ: 233 идэвхтэй байрны зөвхөн 4-д групп
     бичигдсэн (хэмжсэн 2026-10-29) тул хасвал жагсаалт бараг хоосрох. */
  const inGrp = (w) => {
    if (!g) return true;
    const wg = digits(w && w.grp_code);
    return !wg || wg.startsWith(g) || g.startsWith(wg);
  };

  const cex = all.filter(inCex);
  const strict = cex.filter((w) => inSection(w) && inGrp(w));
  if (strict.length || !cex.length) {
    return { rows: strict, widened: false };
  }
  return { rows: cex, widened: true };
}

export default filterWorkplaces;
